"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactToastNotifications = require("react-toast-notifications");
var _Alert = _interopRequireDefault(require("../../Alert/Alert"));
var _constants = require("../../../constants");
var _envConstants = require("../../../env-constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var countryTextHelper = function countryTextHelper(selectedDestination) {
  if (selectedDestination.id === _constants.TYW_DESTINATION.CROATIA_ULTRA) {
    return 'Ultra';
  } else if (selectedDestination.id === _constants.TYW_DESTINATION.CROATIA_HIDEOUT) {
    return 'Hideout';
  }
  return selectedDestination.country;
};
var UrgencyNotification = function UrgencyNotification(_ref) {
  var selectedDestination = _ref.selectedDestination,
    useAlert = _ref.useAlert,
    setShowNotification = _ref.setShowNotification,
    alertClassName = _ref.alertClassName;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    notificationData = _useState2[0],
    setNotificationData = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    notificationText = _useState4[0],
    setNotificationText = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isToastAdded = _useState6[0],
    setIsToastAdded = _useState6[1];
  var _useToasts = (0, _reactToastNotifications.useToasts)(),
    addToast = _useToasts.addToast,
    updateToast = _useToasts.updateToast,
    toastStack = _useToasts.toastStack,
    removeAllToasts = _useToasts.removeAllToasts;
  (0, _react.useEffect)(function () {
    if (_envConstants.ENV.NODE_ENV !== 'development') {
      updateGoogleAnalyticsData();
      var interval = setInterval(function () {
        updateGoogleAnalyticsData();
      }, 120000);
      return function () {
        return clearInterval(interval);
      };
    }
  }, []);
  (0, _react.useEffect)(function () {
    setNotificationText(formatNotificationText(notificationData, selectedDestination));
    if (!useAlert) {
      var activeToastId = (toastStack === null || toastStack === void 0 ? void 0 : toastStack.length) && toastStack[0].id;
      if (!isToastAdded && notificationText) {
        addToast( /*#__PURE__*/_react["default"].createElement("span", null, notificationText));
        setIsToastAdded(true);
      }
      if (isToastAdded && notificationText) {
        updateToast(activeToastId, {
          content: /*#__PURE__*/_react["default"].createElement("span", null, notificationText)
        });
      }
      if (isToastAdded && !notificationText) {
        removeAllToasts();
      }
    }
  }, [selectedDestination, notificationData, notificationText]);
  var updateGoogleAnalyticsData = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          fetch('/api/yl/get-urgency-notification-data', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            },
            credentials: 'same-origin'
          }).then(function (res) {
            return res.json();
          }).then(function (_ref3) {
            var data = _ref3.data;
            setNotificationData(data);
          })["catch"](function (ex) {
            return console.warn('failed fetching urgency notification data', ex);
          });
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), []);
  var formatNotificationText = function formatNotificationText(data, selectedDestination) {
    if (!data || data.totalCount < parseInt(data.threshold, 10)) {
      return null;
    }
    var notificationTypeText = "bookings in last ".concat(data.daysAgo, " days");
    var destinationText = '';
    var count = data.totalCount;
    if ((data === null || data === void 0 ? void 0 : data.type) === 'googleAnalytics') {
      notificationTypeText = 'people browsing';
    }
    if (selectedDestination) {
      var _data$dataByDestinati;
      var countOnDestination = parseInt((_data$dataByDestinati = data.dataByDestination[selectedDestination.id]) === null || _data$dataByDestinati === void 0 ? void 0 : _data$dataByDestinati.count, 10);
      if (countOnDestination >= data.threshold) {
        var country = countryTextHelper(selectedDestination);
        destinationText = "".concat(country);
        if ((data === null || data === void 0 ? void 0 : data.type) === 'bookings') {
          destinationText = "for ".concat(country);
        }
        count = countOnDestination;
      }
    }
    return "<span class=\"d8-u-text-extra-bold\">".concat(count, "</span> ").concat(notificationTypeText, " ").concat(destinationText);
  };
  if (useAlert) {
    return /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
      className: alertClassName,
      type: "hot",
      show: !!notificationText,
      onClose: function onClose() {
        return setShowNotification(false);
      },
      text: function text() {
        return /*#__PURE__*/_react["default"].createElement("span", {
          dangerouslySetInnerHTML: {
            __html: notificationText
          }
        });
      }
    });
  }
  return null;
};
UrgencyNotification.propTypes = {
  selectedDestination: _propTypes["default"].object,
  useAlert: _propTypes["default"].bool,
  setShowNotification: _propTypes["default"].func.isRequired,
  alertClassName: _propTypes["default"].string
};
var _default = exports["default"] = UrgencyNotification;